import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';

export function formatNumber(value: number) {
  return numberToPrettyString(Math.ceil(value));
}
